import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { isAuthenticated } from './services/auth';

import Identificacao from './pages/Identificacao/';
import Preview from './pages/Preview/';
import Documentos from './pages/Documentos/';
import Habilitacao from './pages/Habilitacao/';
import Chamamentos from './pages/Chamamentos';
import DocumentosPSVO from './pages/DocumentosPSVO';
import PageNotFound from './pages/PageNotFound';
import Fips from './pages/Fips';
import CalculadoraModalidades from './pages/CalculadoraModalidades';

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props => {
            const { vestibular } = props.match.params;
            return isAuthenticated(vestibular) ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: `/identificacao/${vestibular}`,
                        state: { from: props.location },
                    }}
                />
            );
        }}
    />
);

const SwitchRoutes = () => {
    return (
        <Switch>
            <Route path="/" exact>
                <Chamamentos />
            </Route>

            <Route path="/identificacao/:vestibular">
                <Identificacao />
            </Route>

            <Route path="/preview/:idproai/:cdsexo">
                <Preview />
            </Route>

            <Route path="/fips/:cd_vestibular">
                <Fips />
            </Route>

            <Route path="/psvo/:vestibular/:token*">
                <DocumentosPSVO />
            </Route>

            <Route path="/calculadora">
                <CalculadoraModalidades />
            </Route>

            <PrivateRoute path="/documentos/:vestibular" component={() => <Documentos />} />

            <PrivateRoute path="/habilitacao/:vestibular" component={() => <Habilitacao />} />

            <Route>
                <PageNotFound />
            </Route>
        </Switch>
    );
};

export default SwitchRoutes;
